/*
 * TODO: Structure error codes similar to backend.
 *       Check ErrorCode class in backend repository.
 */
export enum FrontendErrorCode {
  AUTH_ERROR = 10001,
  NO_UNIT = 10002,
  NO_APPLICATION = 10002,
  FILE_BASE64 = 10003,
  FETCH_ERROR = 10004,
}
